import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE, timeout: 600000 });
client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

const enc = (s) => encodeURIComponent(s);

export async function listPages(status) {
  const { data } = await client.get('/analysis-pages', { params: status ? { status } : undefined });
  return data.pages || [];
}
export async function createPage(payload) {
  const { data } = await client.post('/analysis-pages', payload);
  return data.page;
}
export async function getPage(idOrSlug) {
  const { data } = await client.get(`/analysis-pages/${enc(idOrSlug)}`);
  return data;
}
export async function updatePage(idOrSlug, patch) {
  const { data } = await client.patch(`/analysis-pages/${enc(idOrSlug)}`, patch);
  return data.page;
}
export async function deletePage(idOrSlug) {
  await client.delete(`/analysis-pages/${enc(idOrSlug)}`);
}

export async function listModules(idOrSlug) {
  const { data } = await client.get(`/analysis-pages/${enc(idOrSlug)}/modules`);
  return data.modules || [];
}
export async function createModule(idOrSlug, payload) {
  const { data } = await client.post(`/analysis-pages/${enc(idOrSlug)}/modules`, payload);
  return data.module;
}
export async function updateModule(idOrSlug, moduleId, patch) {
  const { data } = await client.patch(`/analysis-pages/${enc(idOrSlug)}/modules`, patch, { params: { item: moduleId } });
  return data.module;
}
export async function deleteModule(idOrSlug, moduleId) {
  await client.delete(`/analysis-pages/${enc(idOrSlug)}/modules`, { params: { item: moduleId } });
}

export async function sendChat(idOrSlug, question) {
  const { data } = await client.post(`/analysis-pages/${enc(idOrSlug)}/chat`, { question });
  return data;
}

const analysisService = {
  listPages, createPage, getPage, updatePage, deletePage,
  listModules, createModule, updateModule, deleteModule,
  sendChat,
};
export default analysisService;
